/**
 * Build the absolute Edge Function URL for any tenant-app caller.
 *
 * Tenant-app subdomains (`{slug}.app.sazeo.io`) are served by the Cloudflare
 * Worker SPA. There is no `/functions/v1` proxy on those hosts — a relative
 * URL would receive index.html with status 200, JSON parsing would throw,
 * and the page would show its `error_title` fallback. Always hit Supabase
 * directly via VITE_SUPABASE_URL.
 *
 * Falls back to the relative path only if the env is somehow missing (the
 * inline `__SAZEO_VITE_ENV__` boot script in every deployed index.html
 * guarantees it on production hosts).
 */
export function buildFunctionUrl(path: string): string {
  const cleaned = path.replace(/^\/+/, '').replace(/^functions\/v1\//, '');
  const supaUrl =
    (import.meta.env?.VITE_SUPABASE_URL as string | undefined) ??
    (typeof globalThis !== 'undefined'
      ? (globalThis as { __SAZEO_VITE_ENV__?: { VITE_SUPABASE_URL?: string } }).__SAZEO_VITE_ENV__
          ?.VITE_SUPABASE_URL
      : undefined);
  if (supaUrl) {
    return `${supaUrl.replace(/\/+$/, '')}/functions/v1/${cleaned}`;
  }
  return `/functions/v1/${cleaned}`;
}
